import React, { Component, Fragment } from "react";
import { Grid, Input, Button } from "semantic-ui-react";
import { connect } from "react-redux";
import classNames from 'classnames';
import { withRouter } from "react-router-dom";
import { googleTracking } from "../../util";
import { Config } from "../../data/config";
import axios from "axios";
//import AutoComplete from '../autocomplete/AutoComplete';
import {
  setUnitNo,
  resetConnection,
  setStatus
} from "../../store/actions/connection";
import {
  NOT_AVAILABLE,
  COMING_SOON,
  UNAVAILABLE,
  AVAILABLE_PREWIRED,
  AVAILABLE_NOT_PREWIRED
} from "../../data/status";
import { getSalesRep } from "../../store/actions/sales-rep";
import { getTaxes } from "../../store/actions/taxes";
import { getBeanid } from "../../store/actions/beanid";

class SignUpFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };

    this.unitRef = React.createRef();
    this.autocomplete = null;
    this.resetError = this.resetError.bind(this);
    this.redirect = this.redirect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.next = this.next.bind(this);
    this.getPrewire = this.getPrewire.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.signupClicked !== prevProps.signupClicked) {
      this.unitRef.current.focus();
    }
  }

  next() {
    const { bid, result_type, unitNo } = this.props;

    if (!unitNo) {
      this.setState({ error: "Unit # is required" });
      return;
    }

    googleTracking({
      event: "GAevent",
      eventCategory: "address-submission",
      eventAction: "submit",
      eventLabel: `${this.props.address}, ${this.props.city}`,
      "address-submitted": `${this.props.address}, ${this.props.city}`
    });

    switch (result_type) {
      case 1: //Available
        this.getPrewire(bid);
        break;
      case 2: //Coming Soon
        this.props.setStatus(COMING_SOON);
        this.redirect();
        break;
      case 3: //Not Available
        this.props.setStatus(NOT_AVAILABLE);
        this.redirect();

        break;
      case 4:
        this.props.setStatus(UNAVAILABLE);
        this.redirect();
        break;
      default:
        this.redirect();
    }
  }

  getPrewire(bid) {
    const { unitNo } = this.props;
    this.setState({
      isLoading: true
    });

    axios
      .get(`${Config.frontApiUrl}/onboarding/prewire/${bid}/${unitNo}`)
      .then(response => {
        const prewire = response.data.port_qualify || {};
        const isPrewired = prewire.prewired || false;
        this.props.setStatus(
          isPrewired ? AVAILABLE_PREWIRED : AVAILABLE_NOT_PREWIRED
        );

        if (isPrewired) {
          googleTracking({
            event: "virtualPageview",
            pageview: "/prewired/step2/get-fibre-now"
          });
        } else {
          googleTracking({
            event: "virtualPageview",
            pageview: "/not-prewired/step2/get-fibre-now"
          });
        }

        this.redirect();
      })
      .catch(errors => {
        this.setState({
          isLoading: false
        });
        let status = null;

        if (errors.response.data.error.message === "unit_not_found") {
          status = AVAILABLE_NOT_PREWIRED;
          googleTracking({
            event: "virtualPageview",
            pageview: "/not-prewired/step2/get-fibre-now"
          });
        } else {
          status = NOT_AVAILABLE;
        }
        this.props.setStatus(status);
        this.redirect();
      });

    this.props.getSalesRep(bid);
    this.props.getTaxes(bid);
    this.props.getBeanid(bid);
  }

  resetError() {
    if (this.state.error) {
      this.setState({ error: null });
    }
  }

  redirect() {
    const { history } = this.props;
    history.push("/check-availability");
  }

  onChange(e) {
    this.props.setUnitNo(e.target.value);
    if (e.target.value) {
      this.setState({
        error: null
      });
    }

  }


  render() {
    const { error } = this.state;
    const { freeMonths, installCost, redirect, status, unitNo } = this.props;

    if (redirect) {
      return null
    }
    else if (status) {
      return (
        <Grid className="promotion-footer fibreready-footer" verticalAlign='middle'>
          <Grid.Column width={16} className="py-0 mb-0" floated='left'>
            <p className="text-grey2 installation-text mt-3 mb-3 sm-text-center">
              <span>{installCost === 0 ? 'Free installation' : `$${installCost} installation`} </span>  {freeMonths > 0 &&
                <Fragment>
                  <span className="mx-4 icon--bull">&bull;	</span>
                  <span> {freeMonths} {freeMonths > 1 ? 'months' : 'month'} free </span>
                </Fragment>
              }
            </p>
          </Grid.Column>
          <Grid.Column width={16} textAlign='left' className="form-xs promotion-form sm-text-center">
            <form className="ui form grid check-address inverted-form promo__unit mx-0" onSubmit={(e) => e.preventDefault()}>
              <div className={classNames("field px-0", { "is-error": error })}>
                <Input
                  className="input__unit"
                  placeholder="Unit #"
                  onChange={this.onChange}
                  defaultValue={unitNo}
                  {...error && {
                    color: "red",
                    icon: "exclamation triangle"
                  }}
                  labelPosition="right"
                  label={
                    <Fragment>
                      <div className="label__text">Unit #</div>
                    </Fragment>
                  }
                  ref={this.unitRef}
                  onKeyPress={this.onKeyPress}
                />
                {error && (
                  <div className="error-text">{error}</div>
                )}
              </div>
              <div className="px-0 promo__signup">
                <Grid className="my-0 mx-0 px-0" textAlign="center">
                  <Button
                    className="btn--full"
                    type="button"
                    size="big"
                    onClick={() => this.next()}
                  >
                    Sign up
                    </Button>
                </Grid>
              </div>
            </form>
          </Grid.Column>
        </Grid>
      )
    }
    else {
      return null;
    }

  }
}


const mapStateToProps = state => {
  return {
    address: state.connection.address,
    freeMonths: state.promotion_info.free_months,
    installCost: state.promotion_info.install_cost,
    redirect: state.promotion_info.redirect,
    status: state.promotion_info.status,
    unitNo: state.connection.unitNo,
    city: state.connection.city,
    result_type: state.connection.result_type,
    bid: state.connection.bid,
    signupClicked: state.app.signupClicked
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resetConnection: () => dispatch(resetConnection()),
    setUnitNo: value => dispatch(setUnitNo(value)),
    setStatus: status => dispatch(setStatus(status)),
    getSalesRep: id => dispatch(getSalesRep(id)),
    getTaxes: id => dispatch(getTaxes(id)),
    getBeanid: id => dispatch(getBeanid(id)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SignUpFooter)
);



// WEBPACK FOOTER //
// ./src/components/footer/SignUpFooter.js